import { ZeroTypeEnum } from '@qlub-dev/qlub-kit/dist/components/Format';
import { TipModeEnum } from '@qlub-dev/qlub-kit/dist/components/Tip/types';
import { IMenuPageMode, ISplashConfig, SplitRealTimeFeeCalcModeEnum } from '../config';
import { ThemeModeEnum } from '../../context/config';

export enum SplitModeTypeEnum {
    empty = '',
    byItem = 'byItem',
    byShare = 'byShare',
    custom = 'custom',
    unknown = 'unknown',
}

export interface IPaymentGatewayView {
    name: string;
    config: any;
    id: string;
    disabled?: boolean;
    type?: any;
}

export interface IPaymentGatewayMany {
    itemsList: Array<IPaymentGatewayView>;
    total: number;
    hasPgGroup: boolean;
}

export enum TipTooltipModeEnum {
    Hide = 'hide',
    Once = 'once',
    OncePerVendor = 'once_per_vendor',
    Always = 'always',
    AlwaysWithTip = 'always_with_tip',
    Show = 'show',
}

export enum SplitModeEnum {
    Disabled = 'disabled',
    Legacy = 'legacy',
    New = 'new',
}

export enum MenuModeEnum {
    PDFMenu = 'pdfMenu',
    ExternalUrl = 'externalUrl',
    ExternalUrlSameTab = 'externalMenuSameTab',
    MultiMenu = 'multiMenu',
    TableUrl = 'tableUrl',
    MultiMenuTab = 'multiMenuTab',
    PdfMenuIOSRedirect = 'pdfMenuIOSRedirect',
}

type voucherTypes = 'promotion' | 'promotionDark' | 'survey' | 'surveyDark' | 'general' | 'generalDark';
export type emailTermsAndConditionsType = 'hide' | 'show';

export enum TipGamificationModeEnum {
    Default = 'default',
    GamificationOn = 'gamificationOn',
    GamificationOff = 'gamificationOff',
}

export enum TipModalTriggerPointConditionEnum {
    TapOnPay = 'tapOnPay',
    ConfirmPaymentType = 'confirmPaymentType',
}

export enum SmartTipModalTriggerPointConditionEnum {
    TapOnPay = 'tapOnPay',
    ConfirmPaymentType = 'confirmPaymentType',
}

export enum TipModalEventConditionEnum {
    ZeroAmount = 'zeroAmount',
    Interaction = 'interaction',
}

export enum SmartTipModalEventConditionEnum {
    ZeroAmount = 'zeroAmount',
    Interaction = 'interaction',
    Both = 'both',
}

export enum MenuPageDescriptionModeEnum {
    TableId = 'tableId',
    TableName = 'tableName',
    PreferredTableName = 'preferredTableName',
    RestaurantName = 'restaurantName',
    Custom = 'custom',
    NoDescription = 'noDescription',
}

export enum BillPageDescriptionModeEnum {
    TableId = 'tableId',
    TableName = 'tableName',
    PreferredTableName = 'preferredTableName',
}

export enum IRestaurantConfigRedirectPatch {
    IdAfterHash = 'idAfterHash',
}

export enum OrderSummaryMode {
    Hide = 'hide',
    Show = 'show',
}

export enum SplashConfigEnum {
    White = 'white',
    Black = 'black',
    Purple = 'purple',
}

export enum ConfirmationPageRedirectEnum {
    Home = 'home',
    Menu = 'menu',
    None = 'none',
}

export enum EnableEnum {
    Enable = 'enable',
    Disable = 'disable',
}

export enum CheckEnum {
    Check = 'check',
    Uncheck = 'uncheck',
}

export enum ODFTypeEnum {
    CheckBox = 'checkBox',
    CloseButton = 'closeButton',
}

export enum ReviewServiceTypeEnum {
    WithGoogleReview = 'withGoogleReview',
    WithoutGoogleReview = 'withoutGoogleReview',
    WithGooglereviewonstarclick = 'WithGooglereviewonstarclick',
}

export enum BooleanEnum {
    True = 'true',
    False = 'false',
}

export enum ConfirmationPageBrandingLayoutEnum {
    Header = 'Header',
    Subtitle = 'Subtitle',
}

export enum RedeemableAdditives {
    Tax = 'tax',
    Commission = 'commission',
}

export enum TipBoxPresentationEnum {
    Show = 'show',
    Hide = 'hide',
}

export enum TipUIv2Enum {
    Enable = 'enable',
    Disable = 'disable',
    Default = 'default',
}

export type TipLabelType = 'satisfaction' | 'service' | 'stars' | 'ticks';

export enum TipLabelTypeEnum {
    Satisfaction = 'satisfaction',
    Service = 'service',
    Stars = 'stars',
    Ticks = 'ticks',
    Disabled = 'disabled',
}

export enum SplitUIVersion {
    V1 = 'v1',
    V2 = 'v2',
}

export enum VersionEnum {
    V1 = 'v1',
    V2 = 'v2',
    V3 = 'v3',
}

export enum BackgroundModeEnum {
    NoRepeat = 'noRepeat',
    Repeat = 'repeat',
    Fixed = 'fixed',
    FitWidth = 'fitWidth',
}

export enum BillOnLandingEnum {
    WithoutSplit = 'withoutSplit',
    WithSplit = 'withSplit',
    WithSplitAndDrawer = 'withSplitAndDrawer',
}

export interface IRestaurantConfig extends ISplashConfig {
    hideSurchargeSubtitle?: boolean;
    previewBill: boolean;
    hideTableName?: boolean;
    hideTableId?: boolean;
    pdfPriority?: string[];
    externalMenuUrl?: string;
    externalMenuSameTab?: boolean;
    vendorInstruction?: string;
    emailTermsAndConditionsV4?: emailTermsAndConditionsType;
    enablePhoneNumberInSplit?: boolean;
    tipOptions?: number[];
    tipMode?: TipModeEnum;
    tipDefault?: number;
    tipTooltip?: TipTooltipModeEnum;
    tipReminderContent?: string;
    tipHide?: boolean;
    mostCommonTip?: number;
    tipGamificationMode?: TipGamificationModeEnum;
    tipModalTriggerCondition?: TipModalTriggerPointConditionEnum;
    tipModalEventCondition?: TipModalEventConditionEnum;
    tipDefaultForTipModal?: number;
    tipModalWithPayment?: boolean;
    tipShowZeroValue?: boolean;
    hideTipAmountTipBox?: boolean;
    tipModalHideNotNow?: boolean;
    tipBoxPresentation?: TipBoxPresentationEnum;
    tipLabelType?: TipLabelTypeEnum;
    splitMode: SplitModeEnum;
    hideLogo?: boolean;
    menuLinks?: string;
    splitOptions?: SplitModeTypeEnum[];
    menuMode?: MenuModeEnum;
    tableMenu?: string;
    tableUrl?: string;
    socialMedia?: string;
    socialMediaHeader?: string;
    showOrderDetails?: string;
    showTipValueDetails?: string;
    hideViewMenuButton?: boolean;
    viewMenuText?: string;
    customerAppColorMode?: string;
    qsrModalShow?: boolean;
    showTableNameInMenu?: boolean;
    comoEnable?: boolean;
    comoBannerDescription?: string;
    comoBannerTitle?: string;
    comoV2Enabled?: boolean;
    comoV2PosID?: string;
    comoV2BranchID?: string;
    comoV2SourceVersion?: string;
    comoV2MinRedeemablePoints?: number;
    comoV2MaxRedeemablePoints?: number;
    comoV2RedeemableAdditives?: RedeemableAdditives[];
    comoV2BannerDescription?: string;
    comoV2BannerTitle?: string;
    comoV2EarnWithoutLogin?: boolean;
    comoV2FreezeRegionalLogin?: boolean;
    comoV2DisplayEarnNote?: boolean;
    comoV2EnableRegistrationFlow?: boolean;
    comoV2RegistrationFields?: string[];
    comoV2RequiredRegistrationFields?: string[];
    comoV2RegistrationTermsLink?: string;
    comoV2EnableLoginPrompt?: boolean;
    comoV2EnableLoginVerificationPrompt?: boolean;
    enableDealsAndGifts?: boolean;
    tickitBannerDescription?: string;
    tickitBannerTitle?: string;
    tickitEnabled?: boolean;
    rotanaEnabled?: boolean;
    rotanaMinRedeemablePoints?: number;
    rotanaMaxRedeemablePoints?: number;
    rotanaLogoUrl?: string;
    loyaltyProgramName?: string;
    loyaltyProgramLogoUrl?: string;
    loyaltyPointIdentifier?: string;
    loyaltyWelcomeLink?: string;
    ventureBannerName?: string;
    voucherDescription?: string;
    voucherTitle?: string;
    voucherStyle?: string;
    voucherType?: voucherTypes;
    voucherUrl?: string;
    defaultLang?: string;
    preventLogoBlur?: boolean;
    queueNumberDigit?: number;
    showQueueNumber?: boolean;
    onlyMenuVendor?: boolean;
    menuPageTitle?: string;
    billPageDescriptionMode?: BillPageDescriptionModeEnum;
    menuPageDescriptionMode?: MenuPageDescriptionModeEnum;
    menuPageDescription?: string;
    menuPageMode?: IMenuPageMode;
    redirectPatch?: IRestaurantConfigRedirectPatch;
    redirectPreventCircular?: boolean;
    promotionalBannerName?: string;
    promotionalBannerImageLink?: string;
    promotionalBannerPlacement?: string;
    promotionalBannerRedirectLink?: string;
    promotionalBannerSize?: string;
    carouselPlacement?: string;
    enablePromotionalBanner?: boolean;
    voucherHasActiveCampaign?: EnableEnum;
    orderSummary?: OrderSummaryMode;
    enableMenuCTAButton?: boolean;
    menuCTAButtonText?: string;
    dinerFeeTooltipText?: string;
    showDinerFeeTooltip?: string;
    enableTipRounding?: boolean;
    enableUserProfile?: EnableEnum;
    enableSSOLogin?: EnableEnum;
    splashEnable?: boolean;
    splashTitle?: string;
    splashDesc?: string;
    splashHideTypography?: boolean;
    splashTheme?: SplashConfigEnum;
    confirmationPageRedirect?: ConfirmationPageRedirectEnum;
    prependQueueNo?: string;
    disableSplitWithPromo?: boolean;
    queueNumberDisplayGroup?: string[];
    exchangeInterruptionMessage?: string;
    reviewEnabled?: EnableEnum;
    reviewMode?: ReviewServiceTypeEnum;
    defaultRate?: number;
    goodRatingThreshold?: number;
    showGoogleReviewRedirectionFlow?: EnableEnum;
    enableGoogleReviewAutoRedirect?: EnableEnum;
    collectCustomerEmail?: boolean;
    collectCustomerMobileNumber?: boolean;
    customerDataCollectionThreshold?: number;
    landingMenuButtonFirst?: BooleanEnum;
    landingOrderButtonFirst?: BooleanEnum;
    themeMode?: ThemeModeEnum;
    isMenuItemCellV2: boolean;
    closingHour?: string;
    openingHour?: string;
    operationalHoursMessageEnable?: boolean;
    enableBrandingInConfirmationPage?: ConfirmationPageBrandingLayoutEnum;
    splitRealTimeFeeCalculation?: SplitRealTimeFeeCalcModeEnum;
    changePayNowButtonTextForSG?: EnableEnum;
    tipRoundingCRV?: number;
    tipRoundingMTC?: number;
    tipUIv2?: TipUIv2Enum;
    tipCustomHeader?: string;
    tipCustomDescription?: string;
    disableFetchingOrder?: boolean;
    useCDN?: boolean;
    useCDNInMenu?: boolean;
    showWaiterName?: boolean;
    enableNewPaymentModule?: boolean;
    invoiceRefreshDsi?: boolean;
    sentryReplay?: boolean;
    paymentTrace?: boolean;
    paymentTraceException?: boolean;
    paymentTraceReplay?: boolean;
    forexUI?: 'v1' | 'v2';
    commissionOptionalDinerFee?: EnableEnum;
    commissionOptionalDinerFeeDefault?: CheckEnum;
    commissionOptionalDinerFeeTooltip?: string;
    inclusiveChargesText?: string;
    inclusiveChargesTextWithTip?: string;
    commissionOptionalDinerFeeLabel?: string;
    splitUIVersion?: SplitUIVersion;
    commissionOptionalDinerFeeUiType?: ODFTypeEnum;
    hideTableNumInOrderSummary?: EnableEnum;
    languageBasedMenu?: string;
    socialDiningView?: VersionEnum;

    // customer background
    customerBackground: string;
    customerBackgroundMode: BackgroundModeEnum;

    // Confirmation page
    confirmationPageFooterMessageText?: string;
    confirmationPageFooterMessageLink?: string;
    confirmationPageFooterMessageVisibility?: EnableEnum;
    emailReceiptVersion?: VersionEnum;
    downloadReceiptEnable?: EnableEnum;
    screenTimeout?: number; // in second
    screenTimeoutText?: string;
    invoiceDisclaimerHeading?: string;
    invoiceDisclaimerDescription?: string;
    currencyCommaSeparator?: EnableEnum;

    reviewFlowAfterReceiptEmail?: EnableEnum;
    discountsAndOffers?: VisibilityEnum;
    landingFooterDisclaimerText?: string;
    landingPayNowText?: string;
    restaurantMobileNumber?: string;

    communicationConsentVisibility?: VisibilityEnum;
    communicationConsentMessage?: string;
    communicationConsentDefault?: CheckEnum;

    landingPageTutorial?: EnableEnum;
    tutorialEnable?: EnableEnum;

    smartTip?: EnableEnum;
    smartTipStepSizesJSONURL?: string;
    smartTipModalEventCondition?: SmartTipModalEventConditionEnum;
    smartTipModalTriggerCondition?: SmartTipModalTriggerPointConditionEnum;
    splitByShareAlgorithm?: VersionEnum;

    // bill on landing
    bolVariant?: BillOnLandingEnum;
    bolCaption?: string;
    bolTimeout?: number;

    // story
    storyEnable?: EnableEnum;
    storyTheme?: string;
    storyBackground?: string;
    storyData?: string;
}

export enum DiscountTypeEnum {
    Fixed = 'fixed',
    Percentage = 'percentage',
}

export enum ZeroPriceModeEnum {
    Zero = 'zero',
    Free = 'free',
    Null = 'null',
}

export interface IDiscountType {
    amount: string;
    type: DiscountTypeEnum;
}

export enum StyleEnum {
    TitleMedium = 'titleMedium',
    TitleSmall = 'titleSmall',
    BodyMedium = 'bodyMedium',
    BodySmall = 'bodySmall',
    BodyMediumStrike = 'bodyMediumStrike',
    BodySmallStrike = 'bodySmallStrike',
}

export enum IconEnum {
    Dollar = 'dollar',
    Yen = 'yen',
    Rial = 'rial',
    Percent = 'percent',
    Bill = 'bill',
    ItemPercent = 'itemPercent',
    ItemBill = 'itemBill',
    Discount = 'discount',
}

export enum ColorEnum {
    Primary = 'primary',
    Secondary = 'secondary',
    HighEmphasis = 'highEmphasis',
    MediumEmphasis = 'mediumEmphasis',
    LowEmphasis = 'lowEmphasis',
    Background = 'background',
    Green = 'green',
}

export enum ConditionEnum {
    Default = '',
    GT = 'gt',
    GTE = 'gte',
    LT = 'lt',
    LTE = 'lte',
    NE = 'ne',
    E = 'e',
    GTD = 'gtd',
}

export type ILayoutLocale = {
    locale: string;
    value: string;
};

export interface ILayout {
    key: string;
    style?: StyleEnum | null;
    icon?: IconEnum | null;
    color?: ColorEnum | null;
    format?: string | null;
    vcond?: ConditionEnum | null;
    hideAltValue?: boolean;
    ignoreFinalValue?: boolean;
    locales?: ILayoutLocale[];
}

export interface IRestaurantCountry {
    name: string;
    code: string;
    isoCode: string;
    phonePrefix: string;
    languageCode: string;
    currencyCode: string;
    currencySymbol: string;
    config?: any;
}

export interface IRestaurantTimezone {
    countryCode: string;
    timezone: string;
}

export interface IRestaurantPos {
    config?: { [key: string]: any } & ISplashConfig;
    posId?: string;
    billLayout?: ILayout[];
    itemLayout?: ILayout[];
}

export interface IRestaurantBrand {
    name: string;
    id: string;
}

export interface IRestaurantPaymentGateway {
    id: string;
    name: string;
    countryCode: string;
    config: { [key: string]: any };
}

export enum CustomerDetailsInterfaceEnum {
    Modal = 'modal',
    Inline = 'inline',
}

export enum CustomerDetailsModeEnum {
    None = 'none',
    OrderDetails = 'orderDetails',
    Preparation = 'preparation',
}

export enum OrderPaymentMethodEnum {
    Default = 'default',
    PayLater = 'payLater',
    NoPayment = 'noPayment',
}

export enum OrderPricePresentationEnum {
    Default = 'default',
    HidePrice = 'hidePrice',
    ShowPrice = 'showPrice',
}

export enum OrderIdPresentationEnum {
    RefId = 'refId',
    TicketId = 'ticketId',
    TicketIdOrRefId = 'ticketIdOrRefId',
    TicketIdAndRefId = 'ticketIdAndRefId',
}

export enum OrderUnavailableItemPresentationEnum {
    HideCategoryHint = 'hideCategoryHint',
    HideCategory = 'hideCategory',
    HideProductHint = 'hideProductHint',
    HideProduct = 'hideProduct',
}

export enum OrderCustomerDetailsKeyEnum {
    Name = 'name',
    Phone = 'phone',
    Address = 'address',
    Email = 'email',
    CarPlate = 'carPlate',
    CarColor = 'carColor',
    CPF = 'cpf',
}

export enum OrderModifierValidationIgnore {
    Min = 'min',
    Max = 'max',
    MultiMax = 'multiMax',
    DistinctMax = 'distinctMax',
}

export enum MenuViewDefaultEnum {
    List = 'list',
    Grid = 'grid',
}

export enum VisibilityEnum {
    Show = 'show',
    Hide = 'hide',
}

export enum OrderPriceRoundingModeEnum {
    Round = 'round',
    Ceil = 'ceil',
    Floor = 'floor',
}

export enum VentureReviewDisplayEnum {
    DisplayOnlyOnEnjoyPage = 'DisplayOnlyOnEnjoyPage',
    DisplayRightAfterOrderPlaced = 'DisplayRightAfterOrderPlaced',
}

export enum DiningOptionDisplayEnum {
    icon = 'icon',
    text = 'text',
}

export enum DiningOptionEnum {
    DineIn = 'DINE-IN',
    TakeAway = 'TAKEAWAY',
    DriveThrough = 'DRIVE-THROUGH',
}

export enum ScheduleInteractionFlowEnum {
    V1 = 'v1',
    V2 = 'v2',
}

export interface IRestaurantOrderConfig {
    skipOnMenuTableUrl?: boolean;
    manualAmount: boolean;
    invoiceShow: boolean;
    categoryAllItems: boolean;
    deliveryEnable: boolean;
    splitEnable: boolean;
    basketEdit?: boolean;
    hideBundlePrice?: boolean;
    orderHistoryDisable?: boolean;
    zeroPriceMode?: ZeroTypeEnum;
    statusTitle?: { [key: string]: string };
    statusDesc?: { [key: string]: string };
    preparationInfoDisable?: boolean;
    preparationInfoText?: string;
    menuInfoDisable?: boolean;
    menuInfoText?: string;
    customerDetailsFields?: OrderCustomerDetailsKeyEnum[];
    customerDetailsRequiredFields?: OrderCustomerDetailsKeyEnum[];
    customerDetailsMode?: CustomerDetailsModeEnum;
    customerDetailsInterfaceMode?: CustomerDetailsInterfaceEnum;
    customerExtraFields?: { [key: string]: string };
    customerDetailsAllowEdit?: boolean;
    paymentMethod: OrderPaymentMethodEnum;
    pricePresentation?: OrderPricePresentationEnum;
    priceRoundingMode?: OrderPriceRoundingModeEnum;
    ctaPricePresentation?: OrderPricePresentationEnum;
    orderIdPresentation?: OrderIdPresentationEnum;
    unavailableItemPresentation?: OrderUnavailableItemPresentationEnum[];
    defaultOrderStatus?: string;
    menuListWithLogo?: boolean;
    multiOrder?: boolean;
    modifierValidationIgnore?: OrderModifierValidationIgnore[];
    qrPasscodeEnable?: boolean;
    qrDynamicPasscodeEnable?: boolean;
    menuOnlyRestaurant?: boolean;
    hideSpecialRequest?: boolean;
    menuViewDefault?: MenuViewDefaultEnum;
    hideComment?: boolean;
    hideNewOrderButton?: boolean;
    enableProductBasedComment?: boolean;
    scheduledOrderEnable?: boolean;
    scheduleInteractionFlow?: ScheduleInteractionFlowEnum;
    scheduledOrderPreparationTime?: number;
    scheduledOrderOffsetTime?: number;
    scheduledOrderOptionGap?: number;
    scheduledOrderFutureDays?: number;
    pagerEnable?: boolean;
    enablePagerAssignMessage?: boolean;
    customerActiveOrderVisibility?: VisibilityEnum;
    enableEditAddedItem?: boolean;
    reviewDisplayStatus?: VentureReviewDisplayEnum;
    specialRequestTitle?: string;
    specialRequestDesc?: string;
    reviewButtonText?: string;
    submitButtonText?: string;
    payTimeout?: number;
    menuItemCellV2?: boolean;
    diningOptionEnable: boolean;
    diningOptionEnableIcons: boolean;
    diningOptionList?: DiningOptionEnum[];
    diningOptionCustomText?: { [key: string]: string };
    allowedInputLanguages?: string[];
    enablePayBillBtn?: boolean;
    useHighQualityImage?: boolean;
    enablePosVerifyingStatus?: boolean;
    pickupOnly?: boolean;
    diningOptionToOmitFields?: Array<{ key: DiningOptionEnum; value: string }> | string;
}

export interface IRestaurantQRMeta {
    menuUrl?: string;
    redirectionUrl?: string;
    group?: string;
}

export enum OrderModeEnum {
    Default = 'default',
    DigitalMenu = 'digital_menu',
    QSR = 'qsr',
    Mixed = 'mixed',
}

export interface IRestaurant {
    id: string;
    unique: string;
    name: string;
    phone: string;
    email: string;
    title: string;
    address1: string;
    address2: string;
    area: string;
    city: string;
    country: IRestaurantCountry;
    externalMenuUrl: string;
    externalMenuFormat: string | null;
    primaryColour: string;
    secondaryColour: string;
    backgroundUrl: string;
    logoBigUrl: string;
    logoSmallUrl?: string;
    googlePlaceId?: string;
    opsMode: string | null;
    config: IRestaurantConfig;
    brand: IRestaurantBrand;
    timezone: IRestaurantTimezone | null;
    posVendor: IRestaurantPos | null;
    paymentGateways?: IRestaurantPaymentGateway[];
    paymentGatewayList: IPaymentGatewayMany;
    discount?: IDiscountType;
    redirect?: string;
    orderMode: OrderModeEnum | null;
    orderConfig: IRestaurantOrderConfig;
    metaObject?: IRestaurantQRMeta;
    meta?: string;
    availablePGs?: string;
}

export interface IExchangeData {
    amount?: string;
    oldCurrencyCode?: string;
    newCurrencyCode: string;
    exchangeRate?: string;
    unsupportedCurrency: boolean;
}

export interface IGetQrDetailPayload {
    cc: string;
    restaurantUnique: string;
    tableID: string;
    f1?: string;
    f2?: string;
    hash?: string;
}

export interface IGetQrDetailConfig {
    ignoreCache?: boolean;
}

export interface IQrDetailsResponse {
    table: {
        id: string;
        preferredName: string;
        revenueCenter: string;
        section: string;
        tableName: string;
    };
}

export interface IPaymentQrCache {
    time: number;
    details: IQrDetailsResponse;
}

export interface ICurrencyFormat {
    cs: string;
    cc: string;
    currencyPrecision: number;
    currencyCommaSeparator: 'enable' | 'disable';
}

export interface ISmartTipStepSizeRange {
    minBill: number;
    maxBill: number;
    stepSizes: number[];
}
